import { Component, OnInit, Input, TemplateRef, ViewChild } from '@angular/core';
import { Exchange1031ViewModel } from '../../shared/models/Exchange1031ViewModel';
import { Trade1031Service } from '../../shared/providers/Trade1031.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { UserManagerService } from '../../shared/providers/user-manager.service';
import { ValidationService } from '../../shared/providers/validation.service';
import { AuthenticationService } from '../../shared/auth/authentication.service'
import { SharedService } from '../../shared/providers/shared.service';
import { IExchangeCodeOutputModel, IExchangeDetailsputModel } from '../../shared/models/ExchangeCodeOutputModel';
import { OfferService } from '../../shared/providers/offer.service';
import { IChartData, InnerData } from '../../shared/models/IChartData';
//import { Chart } from 'angular-highcharts';
import { LoaderService } from '../../shared/providers/loader.service';
import { IDashboardOModel, IExchangeInvites, IExchangeInvitesList } from '../../shared/models/DashboardDataOModel';
import { TabDirective } from 'ngx-bootstrap/tabs';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
/*import { CompleterService, CompleterData, Ng2CompleterModule } from 'ng2-completer';*/
import { RestService } from '../../shared/providers/rest.service';
import { ToastService } from '../../shared/providers/toast.service';
import { BreadCrumbInput } from '../../shared/models/BreadCrumbInputModel';
import { CommonService } from '../../shared/providers/common.service';
import { IMessageInput } from '../../shared/models/MessageInputModel';
import { IPropertyChatModel } from '../../shared/models/PropertyChatModel';
import { PropertyListingService } from '../../shared/providers/property-listing.service';

export enum Permissions {
  ReadOnly = 2400,
  FullControl = 2401
}

export enum Tabs {
  Dashboard = 1,
  Portfolio = 2,
  Exchange = 3,
  Deals = 4,
  Profile = 5
}


@Component({
  selector: 'dashboard-1031',
  templateUrl: './1031-dashboard.component.html',
  styleUrls: ['./1031-dashboard.component.css']
})
export class Dashboard1031Component implements OnInit {

  exchange1031Id: string = '';
  trade1031InputModel = {} as Exchange1031ViewModel;
  showEdit = false;
  dataService: [];/*CompleterData;*/
  showDashboard = false;
  sellerId: any;
  noData = false;
  tab = Tabs;
  ExchangeInvitesList: IExchangeInvitesList[];
  showInfo = false;
  IsAssignedAgent: boolean = false;
  messageInput = {} as IMessageInput;
  unreadMessageCount: number;
  propertyChatModel = {} as IPropertyChatModel;
  dashboardenabled: boolean = false;
  currentMenu: '';
  prevPage = '';
  prevPageRouteLink = '';
  IsFromParent: boolean = false;
  constructor(private _trade1031Service: Trade1031Service, private activatedRoute: ActivatedRoute, private router: Router,
    private _userManagerService: UserManagerService, public _validationService: ValidationService, public Authentication: AuthenticationService,
    private Shared: SharedService, private offerService: OfferService, public Validation: ValidationService, private Loader: LoaderService,
    private modalService: BsModalService, private _restService: RestService, private Toast: ToastService,
    private commonService: CommonService, private _propertyService: PropertyListingService) {
    //const remoteDataProvider = completerService.remote(_restService.getBaseUrl + '/common/principalListByEmailAutoComplete/', 'Name', 'Name');
    //remoteDataProvider.urlFormater(x => {
    //  return encodeURI(_restService.getBaseUrl + '/common/principalListByEmailAutoComplete/' + x + "/" + this.LoggedInUser.Id);
    //});
    //this.dataService = remoteDataProvider;

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      if (params['tab'] !== undefined && params['tab'] !== null && params['tab'] !== '') {
        this.activeTabName = params['tab'];
      }
      if (params['info'] !== undefined && params['info'] !== null && params['info'] !== '') {
        this.showInfo = params['info'];
      }
      if (params['activeTab'] != null && params['activeTab'] != '' && params['activeTab'] != undefined) {
        let exchangetab = params['activeTab'];
        localStorage.setItem('ExchangeCurrentTab', exchangetab);
      }
      if (params['prevroute'] !== undefined && params['prevroute'] !== null && params['prevroute'] !== '') {
        this.prevPage = params['prevroute'];
        this.IsFromParent = true;
      }
      if (params['link'] !== undefined && params['link'] !== null && params['link'] !== '') {
        this.prevPageRouteLink = params['link'];
      }
    });

    this.activatedRoute.queryParams.subscribe((params: Params) => {
      let fromMenu = params['fromMenu'];
      if (fromMenu !== null && fromMenu !== undefined) {
        this.currentMenu = fromMenu;
      }
    });

    this.LoggedInUser = this.Authentication.user;
    this.sellerId = this.LoggedInUser.Id;
    if (this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031)) {
      this.IsPrincipal = true;
      this._userManagerService.getUserDetails(this.LoggedInUser.Guid).subscribe(response => {
        this.dashboardenabled = response.Is1031EnabledId == 1051 ? true : false;
        if (!this.dashboardenabled) {
          this.router.navigateByUrl('dashboard-1031-preview');
        }
      });
    }
  }
  selectedExchangeLocation = "";
  LoggedInUser: any;
  selectedExchange: number = 0;
  DashboardOModel: IDashboardOModel[];
  showAllExchange = false;

  userGuidToView = '';
  PrincipalId = 0;
  exchangeSelected = 0;
  showTimeChart = false;
  exchangeCodes: IExchangeCodeOutputModel[];
  show = false;
  IsPrincipal = false;
  heading = "1031 Trade";
  breadCrumbInput = {} as BreadCrumbInput;
  breadCrumbPortfolio = {} as BreadCrumbInput;
  Is1031DashboardEnabled = false;
  ngOnInit() {

    this.activatedRoute.params.subscribe((params: Params) => {
      this.breadCrumbInput.PrevPageName = "1031 Trade";
      this.breadCrumbInput.PrevPageLink = this.router.url.split('?')[0];

      this.breadCrumbPortfolio.PrevPageName = "Pipeline";
      this.breadCrumbPortfolio.PrevPageLink = this.router.url.split('?')[0];




      this.loader(true);

      this.exchange1031Id = params.id;
      this.showTimeChart = false;
      this.showOffers = false;
      if (!this.Validation.IsinValid(this.exchange1031Id)) {
        this.exchangeGuid = this.exchange1031Id;

        this._trade1031Service.GetExchange1031DetailsByGuid(this.exchange1031Id, this.LoggedInUser.Id).subscribe(res => {
          this.exchangeDetails = res;
          this.selectedExchange = res.Id;
          if (this.IsPrincipal == false) {
            this.onViewBroker();
          }
          this.bindExchange(0);
          this.exchangeSelected = this.selectedExchange;
          this.loadExchangeDetails(0);
          this.loadDashboardData();
        });
      }
      else {
        this.bindExchange(1);
      }



      //if (this.showInfo) {
      //    this.Toast.clearAllToast();
      //    this.Toast.addToast({
      //        title: 'Search for replacement property', msg: '', timeout: 0, theme: 'bootstrap', position: 'bottom-right', type: 'info'
      //    })
      //}
    });
  }

  ngAfterViewInit() {
    this.addnotification();
    // this.GetMessageUnreadMessageCount();
  }

  async addnotification() {
    await this.commonService.addNotificationToBeBrokers(this.LoggedInUser.Id, 0).subscribe(response => {
    });
  }

  showConnectedExchangeInfo() {
    let exchange = this.exchangeCodes.find(x => x.Id == this.selectedExchange);
    if (exchange) {
      if (exchange.ExchangeType == 1) {
        this.IsConnectedExchange = true;
      }
      else {
        this.IsConnectedExchange = false;
      }
    }
  }
  assignedBrokerCount = 0;
  onViewBroker() {
    this.assignedBrokerCount = 0;
    this._trade1031Service.GetExchangeBrokers(this.selectedExchange).subscribe(res => {
      this.ExchangeInvitesList = res;
      this.assignedBrokerCount = this.ExchangeInvitesList.length;
    });
  }
  onViewPipeline() {
    window.scrollTo(0, 0);
    this.changeActiveTab("portfolio");
  }

  onGenerateExchange1031Report() {
    var newDate = new Date();
    var offset = newDate.getTimezoneOffset() / 60;
    const httpHeader = this.Validation.GetAuthHeader();
    this._propertyService.generateExchange1031(this.exchangeDetails.Id, this.LoggedInUser.Id, offset, this.exchange1031Id).subscribe(resp => {
      let filenameWithExtension: string = resp.toString();
      let filenameWithoutExtension = filenameWithExtension.toString().split('.')[0];
      this.Validation.downloadPDFFile('/upload/pdffile/' + filenameWithoutExtension, filenameWithExtension);
    });
  }

  onHomeBreadCrumbClick() {
    this.router.navigateByUrl('/principal-dashboard');
  }

  showOrHidePageContent() {
    const index: number = (this.ExchangeInvitesList != undefined ? this.ExchangeInvitesList.findIndex(x => x.Id == this.LoggedInUser.Id) : -1);
    if (index !== -1) {
      this.IsAssignedAgent = true;
    }
    if (!this.exchangeDetails.ShowDashboard) {
      this.noData = true;
    }
    else {
      this.noData = false;
    }
    this.loader(false);
  }
  bindExchange(callType) {
    this.Authentication.isLoggedIn.subscribe(response => {

      if (response) {
        if (this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031) || this.Authentication.IsUserRole(this.Authentication.UserRole.Broker)) {
          this._trade1031Service.GetExchangeCode(this.LoggedInUser.Id).subscribe(res => {
            this.exchangeCodes = res;
            //this.exchangeCodes.forEach(item => {
            //    let ProjectedSaleDate = this.Validation.convertUTCDateToLocalDate(item.ProjectedSaleDate);
            //    item.ExchangeCode = item.ExchangeCode + "  " + this.Validation.formatDatetoMMDDYYYY(ProjectedSaleDate);
            //    let SaleDateEnd = this.Validation.convertUTCDateToLocalDate(this.Validation.addDays(ProjectedSaleDate, 180));
            //    item.ExchangeCode = item.ExchangeCode + " - " + this.Validation.formatDatetoMMDDYYYY(SaleDateEnd);
            //});

            if (this.exchangeCodes.length <= 0) {
              this.show = false;
            }
            else {
              this.show = true;
            }
            if (callType === 1) {
              if ((this.Shared.GetselectedExchangeId === null || this.Shared.GetselectedExchangeId === "0") && this.exchangeCodes.length > 0) {
                this.selectedExchange = this.exchangeCodes[0].Id;
              }
              else if (this.Shared.GetselectedExchangeId !== null) {
                this.selectedExchange = parseInt(this.Shared.GetselectedExchangeId);
              }
              this.exchangeSelected = this.selectedExchange;
              //if (this.selectedExchange > 0) {
              this.loadExchangeDetails(1);
              this.loadDashboardData();
              //}
              //else {
              //  this.router.navigateByUrl('dashboard-1031-preview');
              //}
            }
            else {
              this.selectedExchange = this.exchangeDetails.Id;
            }
            this.showConnectedExchangeInfo();
            //this.GetMessageUnreadMessageCount();
          });
        }
        else {
          this.noData = false;
          this.loader(false);
        }

      }
    });
  }
  exchangeStarted = false;
  exchangeDetails = {} as IExchangeDetailsputModel;
  identificationPeriod: Date;
  finalCloseDate: Date;
  showOffers = false;

  value: string;
  activeTabName = "";
  showTradePortfolio = false;
  showExchange = false;
  showDeals = false;
  showProfile = false;
  onTabSelect(data: TabDirective, selectedTab: number): void {

    if (!this._validationService.IsinValid(data.id)) {

      this.showTimeChart = false;
      this.showTradePortfolio = false;
      this.showExchange = false;
      this.showDeals = false;

      this.value = data.heading;
      this.activeTabName = data.id;
      let url = this.router.url.split('?')[0];
      if (selectedTab === Tabs.Dashboard) {
        this.showTimeChart = false;
        this.loadDashboardData();
        this.activeTabName = "dashboard";
      }
      else if (selectedTab === Tabs.Portfolio) {
        this.showTradePortfolio = true;
        this.activeTabName = "portfolio";
      }
      else if (selectedTab === Tabs.Exchange) {
        this.showExchange = true;
        this.activeTabName = "exchange";
      }
      else if (selectedTab === Tabs.Deals) {
        this.showDeals = true;
        this.activeTabName = "offers";
      }
      else if (selectedTab === Tabs.Profile) {
        this.showProfile = true;
        this.activeTabName = "profile";
      }
    }
  }
  IsConnectedExchange = false;
  exchangeGuid = "";
  bindData() {
    if (this.activeTabName === '') {
      this.activeTabName = 'dashboard';
    }
    this.Shared.setExchange(this.selectedExchange);
    this._trade1031Service.GetExchangeDetails(this.selectedExchange, this.LoggedInUser.Id).subscribe(res => {
      this.exchangeGuid = res.ExchangeGuid;
      if (res.ShowDashboard) {
        this.noData = false;
        if (this.currentMenu != null && this.currentMenu != '' && this.currentMenu != undefined) {
          this.router.navigateByUrl('/dashboard-1031/' + res.ExchangeGuid + "?tab=" + this.activeTabName + "&fromMenu=" + this.currentMenu);
        }
        else {
          this.router.navigateByUrl('/dashboard-1031/' + res.ExchangeGuid + "?tab=" + this.activeTabName);
        }
      }
      else {
        if (this.currentMenu != null && this.currentMenu != '' && this.currentMenu != undefined) {
          this.router.navigateByUrl('/dashboard-1031/' + "?fromMenu=" + this.currentMenu);
        }
        else {
          this.router.navigateByUrl('/dashboard-1031/');
        }
      }
    });
  }
  showLoader = false;
  loader(showOrHide: boolean) {
    this.showLoader = showOrHide;
  }
  IsBroker = false;
  async loadExchangeDetails(type) {
    if (this.selectedExchange > 0) {
      //this.Loader.display(true);
      await this._trade1031Service.GetExchangeDetails(this.selectedExchange, this.LoggedInUser.Id).subscribe(res => {
        this.exchangeDetails = res;
        if (this.exchangeDetails.ShowDashboard) {
          if (!this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031)) {
            this.heading = this.exchangeDetails.Principal + " - " + this.exchangeDetails.ExchangeCode;
          }

          this.userGuidToView = res.UserGuid;
          this.PrincipalId = res.UserId;
          this.showOffers = true;
          this.showTimeChart = true;
          if (this.Authentication.IsUserRole(this.Authentication.UserRole.Principal1031) && res.UserId === this.LoggedInUser.Id) {
            this.showAllExchange = true;
          }
          else {
            this.showAllExchange = false;
          }

          if (this.Authentication.IsUserRole(this.Authentication.UserRole.Broker)) {
            this.IsBroker = true;
          }

          this.setDates();
        }

        setTimeout(() => {
          this.showOrHidePageContent();
        }, 100);
        //this.Loader.display(false);
      });

    }
    else {
      this.noData = true;
      this.loader(false);
    }
  }
  closeDate(closeDate: Date) {
    this.finalCloseDate = closeDate;
  }
  setDates() {
    this.exchangeDetails.ProjectedSaleDate = this.exchangeDetails.ProjectedSaleDate ? this._validationService.convertUTCDateToLocalDate(this.exchangeDetails.ProjectedSaleDate) : null;
    let ProjectedSaleDate = this.exchangeDetails.ProjectedSaleDate;
    //this.exchangeDetails.ExchangeCode = this.exchangeDetails.ExchangeCode + "  " + this._validationService.formatDatetoMMDDYYYY(ProjectedSaleDate);
    let SaleDateEnd = this._validationService.convertUTCDateToLocalDate(this._validationService.DateAdd(ProjectedSaleDate, 180));
    //this.exchangeDetails.ExchangeCode = this.exchangeDetails.ExchangeCode + " - " + this._validationService.formatDatetoMMDDYYYY(SaleDateEnd);
    this.identificationPeriod = this.Validation.DateAdd(this.exchangeDetails.ProjectedSaleDate, 45);
    this.finalCloseDate = this.Validation.DateAdd(this.exchangeDetails.ProjectedSaleDate, 180);
  }

  async loadDashboardData() {
    if (this.selectedExchange > 0) {
      await this._trade1031Service.GetDashboardData(this.selectedExchange).subscribe(res => {
        this.DashboardOModel = res.filter(x => x.Title != 'Suggested' && x.Title != 'Declined/Cancelled');
        this.showDashboard = true;
        this.showTimeChart = true;

        this.DashboardOModel.forEach(item => {
          if (item.Title == 'Favorites') {
            item.Color = " #003A5D ";
          }
          else if (item.Title == 'Pending Offer') {
            item.Color = " #A7A8A9 ";
          }
          else if (item.Title == 'Offer Accepted') {
            item.Color = " #02C29F ";
          }
          else if (item.Title == 'Hard Contract') {
            item.Color = " #FFC32B ";
          }
          else if (item.Title == 'Under Contract') {
            item.Color = " #59595B ";
          }
          else if (item.Title == 'Closed Deals') {
            item.Color = " #FF4438 ";
          }
        })
      });
    }
    else {
      this.noData = true;
      this.loader(false);
    }
  }

  checkDatePassed(dateToCheck: Date) {
    let date = this._validationService.convertDateToUTCStamp(this._validationService.formatDatetoMMDDYYYY(dateToCheck));
    let currentDate = this._validationService.convertDateToUTCStamp(this._validationService.formatDatetoMMDDYYYY(new Date()));
    if (date < currentDate) {
      return 'success';
    }
    else if (date === currentDate) {
      return 'active';
    }
    else if (date > currentDate) {
      return 'inactive';
    }
  }

  colors = ["#ec5555", "#ec5555", "#f2bd66", "#5bc8af", "#198fde", "#8647b3", "#e47220"]
  getColor(index) {
    return this.colors[index];
  }

  onCancel() {
    this.router.navigate(['/1031-exchanges']);
  }

  modalRef: BsModalRef;
  modalRefInvite: BsModalRef;
  openModal(template: TemplateRef<any>, classes) {
    this.modalRefInvite = this.modalService.show(template, { class: classes });
  }
  openBrokerModal(template: TemplateRef<any>, classes) {
    this.onViewBroker();
    this.modalRef = this.modalService.show(template, { class: classes });
  }

  changeActiveTab(activeTab) {
    this.activeTabName = activeTab;
  }
  onClose(close: boolean) {
    if (close) {
      this.modalRef.hide();
    }
  }
  onInviteClose(status: boolean) {
    //this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
  }
  reload(status: boolean) {
    if (this.router.url.indexOf("?tab=exchange") > -1) {
      this.modalRefInvite.hide();
      this.router.navigateByUrl("redirect?url=" + encodeURIComponent(this.router.url), { skipLocationChange: true });
    }
  }

  openMessageTab(template: TemplateRef<any>, classes) {
    this.propertyChatModel.ExchangeId = this.exchangeSelected;
    this.propertyChatModel.PropertyGuid = null;
    this.Shared.clickMessage(this.propertyChatModel);
  }
  async GetMessageUnreadMessageCount() {
    this.messageInput.CreatedById = this.LoggedInUser.Id;
    this.messageInput.ObjectTypeId = 301;
    this.messageInput.ExchangeId = this.selectedExchange;
    await this.commonService.GetMessageUnreadMessageCount(this.messageInput).subscribe(responds => {
      this.unreadMessageCount = responds;
    });
  }
  setUnreadMessageCount(count) {
    this.unreadMessageCount = count;
  }
  onExchangeBreadCrumbClick() {
    let exchangetab = "1";
    if (localStorage.getItem('ExchangeCurrentTab') != null && localStorage.getItem('ExchangeCurrentTab') != '' && localStorage.getItem('ExchangeCurrentTab') != undefined) {
      exchangetab = localStorage.getItem('ExchangeCurrentTab');
      localStorage.removeItem('ExchangeCurrentTab');
    }
    this.router.navigate(['/1031-exchanges'], { queryParams: { activetab: exchangetab } });
  }

  onBreadCrumbClick() {
    this.router.navigateByUrl(this.prevPageRouteLink);
  }
}
